import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormControl } from '@angular/forms'
import { FormValidatorHelper } from '../../../helpers/form-validator.helper'

@Component({
    selector: 'app-control-error',
    templateUrl: './control-error.component.html',
    styleUrls: ['./control-error.component.scss'],
})
export class ControlErrorComponent implements OnInit {
    @Input() control!: FormControl
    @Input() label!: string
    @Input() hideLabel: boolean = false
    @Input() standAloneForm: boolean = false
    @Output() onError = new EventEmitter<boolean>()

    ngOnInit(): void {
        if (!this.control) {
            console.error('using error control without binding to an existing formControl')
        }

        if (!this.label && !this.hideLabel) {
            console.error('using error control without input label')
        }
    }

    canShowError() {
        return (
            this.control.touched &&
            this.control.invalid &&
            !this.hideLabel &&
            !this.control.pristine
        )
    }

    getErrorMessage() {
        const errors = this.control.errors

        if (errors && this.canShowError()) {
            for (const errorName in this.control.errors) {
                if (this.control.errors.hasOwnProperty(errorName)) {
                    this.onError.emit(true)
                    return FormValidatorHelper.getErrorMessage(
                        this.label,
                        errorName,
                        this.control.errors[errorName],
                    )
                }
            }
        }

        this.onError.emit(false)
        return ''
    }
}
